/* eslint-disable @typescript-eslint/naming-convention */
export const generateExternalType = (externalType: 'vendor' | '' = '') =>
  externalType ? { 'x-external-type': externalType } : {}

export const gengerateVendorPathExtension = (isVendor: boolean) => (isVendor ? '/vendor' : '')

export const gengerateVendorAPIVersion = (isVendor: boolean, defaultVersion: string) =>
  isVendor ? 'v1' : defaultVersion
